import React, { useState } from 'react';
import { testimonials } from '../data/testimonials';
import '../styles/Testimonials.css';

const Testimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleDotClick = (index) => {
    if (index === activeTestimonial || isTransitioning) return;
    
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveTestimonial(index);
      setTimeout(() => {
        setIsTransitioning(false);
      }, 50);
    }, 300);
  };

  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  const safeIndex = Math.min(activeTestimonial, testimonials.length - 1);

  return (
    <div className="testimonials-column">
      <h2 className="section-title">Testimonials</h2>
      <div className="testimonial-content">
        <blockquote className={`testimonial-quote ${isTransitioning ? 'swipe-out-left' : 'swipe-in'}`}>
          "{testimonials[safeIndex].quote}"
        </blockquote>
        <div className={`customer-info ${isTransitioning ? 'swipe-out-left' : 'swipe-in'}`}>
          <div className="customer-avatar">
            <img src={testimonials[safeIndex].avatar} alt={testimonials[safeIndex].name} loading="lazy" />
          </div>
          <div className="customer-details">
            <h4>{testimonials[safeIndex].name}</h4>
            <p>{testimonials[safeIndex].position}</p>
          </div>
        </div>
        <div className="testimonial-navigation">
          <div className="dots">
            {testimonials.map((_, index) => (
              <span 
                key={index}
                className={`dot ${activeTestimonial === index ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              ></span>
            ))}
          </div>
          <div className="rating">
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
